import React from "react";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowLeft } from "react-icons/hi";


const BackButton = ({ to = "/ChequeGaurdDashboard", label = "Back to Dashboard", className = "" }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 ${className}`}
    >
      <HiArrowNarrowLeft className="h-4 w-4" />
      {label}
    </button>
  );
};

export default BackButton;
